import { TableModal, useTableRow } from "@zapier/tables";
import AssetRow from "./AssetRow";
import {
  HydratedTable,
  HydratedTableAsset,
  HydratedVirtualTableAsset,
} from "@zapier/client";
import { useTranslations } from "@zapier/i18n";
import { FolderModal } from "@zapier/shared";

interface Props {
  allowSelection?: boolean;
  table: HydratedTableAsset | HydratedVirtualTableAsset;
  setCurrentModal: (modal: TableModal | FolderModal | undefined) => void;
  setCurrentTable: (
    table:
      | HydratedTableAsset
      | HydratedVirtualTableAsset
      | HydratedTable
      | undefined,
  ) => void;
  folderId?: string;
  showLastRun?: boolean;
  showLocationColumn?: boolean;
  onCopyToAnotherAccount?: (
    asset: HydratedTableAsset | HydratedVirtualTableAsset,
  ) => void;
}

export function AssetRowTable({
  allowSelection,
  table,
  setCurrentModal,
  setCurrentTable,
  folderId,
  showLastRun,
  showLocationColumn,
  onCopyToAnotherAccount,
}: Props) {
  const tShared = useTranslations("fallbacks");
  const { menuItems, triggerPermissionsCheck } = useTableRow({
    table,
    setCurrentModal,
    setCurrentTable,
    onCopyToAnotherAccount,
  });

  return (
    <AssetRow
      allowSelection={allowSelection}
      asset={table}
      folderZapTableRow={true}
      isUntitled={table?.name?.length === 0}
      title={table.name || tShared("untitled-asset", { assetType: "Table" })}
      updatedAt={new Date(table.editedAt)}
      menuItems={menuItems}
      onOpenMenu={triggerPermissionsCheck}
      folderId={folderId}
      showLastRun={showLastRun}
      showLocationColumn={showLocationColumn}
    />
  );
}
